// extracted by mini-css-extract-plugin
export const root = "welcome-animation-module--root--1kyyv";
export const hide = "welcome-animation-module--hide--1zhZ-";